"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const CollapsibleNavigation = _ref => {
  let {
    title,
    items,
    expandedIcon: expandedIconProp,
    collapsedIcon: collapsedIconProp,
    classnames
  } = _ref;
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const expandedIcon = expandedIconProp || 'chevron-up';
  const collapsedIcon = collapsedIconProp || 'chevron-down';
  const onClick = () => setIsExpanded(!isExpanded);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: (0, _classnames.default)(_indexModule.default.CollapsibleNavigation, classnames === null || classnames === void 0 ? void 0 : classnames.wrapper)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.heading
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-hidden": "true",
    className: _indexModule.default.toggleItems,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: isExpanded ? expandedIcon : collapsedIcon,
    size: "medium"
  })), title), /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)(_indexModule.default.items, classnames === null || classnames === void 0 ? void 0 : classnames.items, {
      [_indexModule.default.isExpanded]: isExpanded
    })
  }, items.map((item, i) => /*#__PURE__*/_react.default.createElement("li", {
    key: "item".concat(i),
    className: (0, _classnames.default)(_indexModule.default.item, classnames === null || classnames === void 0 ? void 0 : classnames.item),
    onClick: onClick
  }, item))));
};
var _default = exports.default = CollapsibleNavigation;